import React, { ComponentProps } from 'react';
import { RestrictedButton, RestrictedIconButton } from '@fullstory/components';
import { useIntl } from 'react-intl';

interface FGACFullButtonProps
  extends Omit<ComponentProps<typeof RestrictedButton>, 'tooltipAction'> {
  iconOnly: false;
  includeTooltipAction?: boolean;
}
interface FGACIconButtonProps
  extends Omit<ComponentProps<typeof RestrictedIconButton>, 'tooltipAction'> {
  iconOnly: true;
  includeTooltipAction?: boolean;
}

export const FGACButton: React.FC<FGACFullButtonProps | FGACIconButtonProps> = ({
  children,
  iconOnly,
  includeTooltipAction = true,
  ...rest
}) => {
  const intl = useIntl();

  const tooltipAction = includeTooltipAction
    ? {
        text: intl.formatMessage({ defaultMessage: 'Learn more', id: 'TdTXXf' }),
        href: 'https://help.fullstory.com/hc/en-us/articles/1500012361902',
      }
    : undefined;

  return iconOnly ? (
    <RestrictedIconButton
      {...(rest as ComponentProps<typeof RestrictedIconButton>)}
      tooltipAction={tooltipAction}
    >
      {children}
    </RestrictedIconButton>
  ) : (
    <RestrictedButton
      {...(rest as ComponentProps<typeof RestrictedButton>)}
      tooltipAction={tooltipAction}
    >
      {children}
    </RestrictedButton>
  );
};

export const getFGACButtonExplorerRoleProps = (
  canUpdate: boolean,
): Pick<
  FGACFullButtonProps,
  | 'lockPosition'
  | 'enabledTooltipVariant'
  | 'includeTooltipAction'
  | 'tooltipPlacement'
  | 'iconOnly'
> => ({
  lockPosition: 'left',
  enabledTooltipVariant: !canUpdate ? 'dark' : 'light',
  includeTooltipAction: canUpdate,
  tooltipPlacement: 'top',
  iconOnly: false,
});

export const getFGACIconButtonExplorerRoleProps = (
  canUpdate: boolean,
): Pick<FGACIconButtonProps, 'enabledTooltipVariant' | 'includeTooltipAction' | 'iconOnly'> => ({
  enabledTooltipVariant: !canUpdate ? 'dark' : 'light',
  includeTooltipAction: canUpdate,
  iconOnly: true,
});
